import React, { FC, useEffect } from "react";
import { Field, Form, FormElement, FormRenderProps } from "@progress/kendo-react-form";
import {
	FormInput,
} from "ui/Topography";
import { useTranslation } from "react-i18next";
import CustomButton from "ui/Button";
import { getCatchSignResetPasswordApi } from "api/sign";
import { useInfoStore } from "store/error";
import { CustomError } from "interface";

import styles from "styles.module.css";

const ForgotSigningPasswordPage: FC<{}> = () => {
	const { t } = useTranslation();
	const onSubmit = () => { };
	const [username, setUsername] = React.useState<string>("");
	const { setError } = useInfoStore();

	useEffect(() => {
		//setUsername("240272VEIODD");
	}, []);


	const resetPassword = () => {
		if (username === "") {
			setError(new CustomError("Brukernavn er p�krevd."));
			return;
		}

		getCatchSignResetPasswordApi(username).then((response) => {
			window.open(response, "_blank");
		})
		.catch((error) => {
			//setError(new CustomError("Brukernavn er p�krevd."));
			setError(error.message);
			console.log(error);
		});

	};


	return (
		<div className={styles.PageContainer} style={{ height: "100%" }}>
			<legend
				className={styles.BoxHeadingLarge}
				style={{ paddingBottom: "20px" }}
			>Glemt signeringspassord</legend>
			<div
				style={{
					/*height: `calc(${pageHeight}px - 400px)`,*/
					height: `100px`,
					overflow: "auto",
				}}
			>
				<Form
					onSubmit={onSubmit}
					render={(formRenderProps: FormRenderProps) => (
						<FormElement style={{ width: "100%" }}>
							<fieldset className={"k-form-fieldset"}>
								<Field
									id="userName"
									onChange={(e) =>
										setUsername(e.target.value)
									}
									name={"Lokalitet"}
									label={t("Username")}
									placeholder=""
									currentValue={username}
									type="text"
									component={FormInput}
								/>
							</fieldset>
						</FormElement>
					)}
				/>
			</div>

			<div>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						flex: 1,
					}}
				>

					<div style={{ display: "flex", gap: "10px" }}>
						<CustomButton
							onClick={resetPassword}
							label={t("Change")}
						/>
					</div>



				</div>
			</div>


		</div>
	);
};

export default ForgotSigningPasswordPage;